'use client'

import { useMemo } from 'react'
import { urlForImage } from 'lib/sanity.image'

import Image from 'next/image'

export const ProductMarketingCards = ({ tabs, activeTab, setActiveTab }) => {
  const hasDetails = useMemo(() => tabs.some((tab) => tab.details), [tabs])

  if (!hasDetails) return null

  return (
    <div className="grid grid-cols-3 gap-16 pt-80">
      {tabs.map((tab) => {
        if (!tab.details) return null
        return (
          <CardPreview
            key={tab.label}
            title={tab.label}
            image={tab.details.image}
            onClick={() => setActiveTab(tab.label)}
          />
        )
      })}
    </div>
  )
}

const CardPreview = ({ image = null, title, onClick }: any) => {
  return (
    <button className="rounded-8 bg-white p-8 text-left" onClick={onClick}>
      <div className="pb-10 text-12 text-midGray">{title}</div>
      <div className="relative aspect-[1/1.25] overflow-hidden rounded-6">
        {image ? (
          <Image
            src={urlForImage(image).width(300).auto('format').url()}
            fill
            alt=""
            style={{ objectFit: 'cover' }}
            placeholder="blur"
            blurDataURL={image.lqip}
            sizes="200px"
          />
        ) : null}
      </div>
    </button>
  )
}
